// src/data/themes.js
export const themes = {
  default: {
    name: 'Mặc định',
    colors: {
      '--primary-bg': '#ffffff',
      '--primary-headline': '#000000',
      '--primary-paragraph': '#7d7a76',
      '--primary-button': '#6678d4',
      '--primary-button-light': '#c0e3f5',
      '--primary-stroke': '#020826',
      '--primary-main': '#ffffff',
      '--primary-highlight': '#a3bffa',
      '--primary-secondary': '#ebeeea',
      '--primary-tertiary': '#f25042',
      '--sidebar-gradient': 'linear-gradient(180deg, #615CA4 18%, #445ABB 59%, #2758D2 100%)',
    },
  },
  sunset: {
    name: 'Hoàng hôn',
    colors: {
      '--primary-bg': '#fff5e1',
      '--primary-headline': '#2c2c2c',
      '--primary-paragraph': '#8c6d52',
      '--primary-button': '#ff7b54',
      '--primary-button-light': '#ffd6c4',
      '--primary-stroke': '#d4a276',
      '--primary-main': '#ffffff',
      '--primary-highlight': '#ff9a8d',
      '--primary-secondary': '#fffaf0',
      '--primary-tertiary': '#ff5733',
      '--sidebar-gradient': 'linear-gradient(180deg, #d4a276 18%, #ff7b54 59%, #ff5733 100%)',
    },
  },
  mint: {
    name: 'Xanh Bạc hà',
    colors: {
      '--primary-bg': '#f0fff4',
      '--primary-headline': '#004d40',
      '--primary-paragraph': '#43a047',
      '--primary-button': '#26a69a',
      '--primary-button-light': '#b2dfdb',
      '--primary-stroke': '#80cbc4',
      '--primary-main': '#ffffff',
      '--primary-highlight': '#80cbc4',
      '--primary-secondary': '#e8f5e9',
      '--primary-tertiary': '#ef5350',
      '--sidebar-gradient': 'linear-gradient(180deg, #4db6ac 18%, #26a69a 59%, #00897b 100%)',
    },
  },
  dark: {
    name: 'Chế độ Tối',
    colors: {
      '--primary-bg': '#121212',
      '--primary-headline': '#ffffff',
      '--primary-paragraph': '#a0a0a0',
      '--primary-button': '#bb86fc',
      '--primary-button-light': '#3c3c3c',
      '--primary-stroke': '#373737',
      '--primary-main': '#1e1e1e',
      '--primary-highlight': '#3700b3',
      '--primary-secondary': '#2c2c2c',
      '--primary-tertiary': '#cf6679',
      '--sidebar-gradient': 'linear-gradient(180deg, #3700b3 18%, #bb86fc 59%, #cf6679 100%)',
    },
  },
};